import { getPrice } from '@fourthwall/utils'

import type { Config, ConfigState } from '../ReferralRecommendation.types'

const getConfigState = (
  {
    onSignUp: { value: recipientSignupValue },
    onMinimumOrderAchieved: { value: recipientOrdersValue },
  }: Config['recipientBonus'],
  {
    onSignUp: { value: referrerSignupValue },
    onMinimumOrderAchieved: { value: referrerOrdersValue },
  }: Config['referrerBonus'],
): ConfigState => ({
  recipient: {
    signup: {
      value: recipientSignupValue,
      price: getPrice(recipientSignupValue),
    },
    orders: {
      value: recipientOrdersValue,
      price: getPrice(recipientOrdersValue),
    },
  },
  referrer: {
    signup: {
      value: referrerSignupValue,
      price: getPrice(referrerSignupValue),
    },
    orders: {
      value: referrerOrdersValue,
      price: getPrice(referrerOrdersValue),
    },
  },
})

const getRecipientBenefitsText = ({ signup }: ConfigState['recipient']) =>
  signup.value > 0 ? `They get ${signup.price} in sample credit on sign up. ` : ''

const getReferralBenefitsText = ({ recipient, referrer }: ConfigState) => {
  let referralBenefitsText = ''

  if (recipient.orders.value === referrer.orders.value && recipient.orders.value > 0) {
    referralBenefitsText = `You each get ${referrer.orders.price} in sample credit`
  } else if (referrer.signup.value > 0) {
    referralBenefitsText = `You get ${referrer.signup.price} in sample credit when they sign up`
    if (referrer.orders.value > 0) {
      referralBenefitsText += ` plus another ${referrer.orders.price} in sample credit`
    }
  } else if (referrer.orders.value > 0) {
    referralBenefitsText = `You get ${referrer.orders.price} in sample credit`
  }

  return referralBenefitsText
}

const getConditionText = (
  signupBonusOauthRequired: Config['signupBonusOauthRequired'],
  minimumOrdersToBonus: Config['minimumOrdersToBonus'],
) => {
  if (signupBonusOauthRequired) {
    return ' if they sign up with their primary social'
  }

  if (minimumOrdersToBonus > 0) {
    return ` once they've made ${minimumOrdersToBonus} or more sales`
  }

  return ''
}

export const getReferralDescription = ({
  recipientBonus,
  referrerBonus,
  minimumOrdersToBonus,
  signupBonusOauthRequired,
}: Config) => {
  const configState = getConfigState(recipientBonus, referrerBonus)
  const recipientBenefitsText = getRecipientBenefitsText(configState.recipient)
  const referralBenefitsText = getReferralBenefitsText(configState)
  const conditionText = getConditionText(signupBonusOauthRequired, minimumOrdersToBonus)

  return `${recipientBenefitsText}${referralBenefitsText}${conditionText}.`
}
